<div class="navbar-left">
  @if (
    (egiAppContext.activeApp$ | async)?.id &&
    (egiAppContext.activeApp$ | async).rootNavigationItem.hasNoneClickTroughChildren
    ) {
    <button
      class="hamburger-btn"
      (click)="toggleSideBar()"
      [title]="(layoutQueries.isSideBarOpen$ | async) ? 'Sluit menu' : 'Open menu'"
      >
      <i eIcon icon="bars"></i>
    </button>
  }

  <div class="logo-pill clickable" (click)="onLogoClick()" [title]="appService.version">
    <span class="logo-pill__primary">{{ viewport.isPhone() ? 'MiM' : 'Mechanics in Motion' }}</span>
    <span class="logo-pill__secondary">Empowerment through awareness</span>
  </div>

  <span class="navbar-divider"></span>

  @if (userQueries.isAnyUserAuthenticated$ | async) {
    <app-egi-app-menu
      class="app-switcher"
    ></app-egi-app-menu>
  }
</div>

<div class="navbar-right">
  <!-- Pas na > 30 s zonder live verbinding (vervangt de vroegere verbindings-toasts). -->
  <egi-live-connection-indicator />

  @if (envBadge) {
    <div class="env-badge"><span class="env-badge__text">{{ envBadge }}</span></div>
  }

  <!-- Nieuwe versie klaar maar nog niet geladen (na "later" in de update-dialoog). -->
  <egi-app-update-indicator />

  <!-- Lopende/afgeronde chart-import: voortgang + rapport, ook buiten de chart manager. -->
  <hd-chart-import-indicator />

  <authenticated-user-indicator></authenticated-user-indicator>
</div>

<e-dialog
  size="md"
  title="Applicatie"
  titleData="Systeem- en omgevingsinformatie"
  noPadding
  [(open)]="showApplicationDialog"
  >
  <application-info></application-info>
</e-dialog>

